export default __webpack_public_path__ + "static/media/bankofamerica-logo.e45a7b44.png";